export default __webpack_public_path__ + "static/media/i.4aa76f52.mp3";